(function () {
  var money = function (cents) {
    return (cents / 100).toLocaleString(window.ZZ_LOCALE || 'tr-TR', {
      minimumFractionDigits: 2, maximumFractionDigits: 2
    }) + ' ' + (window.ZZ_CURRENCY_SYMBOL || 'TL');
  };

  /* ---------- cart drawer ---------- */
  var drawer = {
    el: null, overlay: null,
    open: function () { if (this.el) { this.el.classList.add('is-on'); this.overlay.classList.add('is-on'); document.body.style.overflow = 'hidden'; document.body.classList.add('zz-drawer-open'); } },
    close: function () { if (this.el) { this.el.classList.remove('is-on'); this.overlay.classList.remove('is-on'); document.body.style.overflow = ''; document.body.classList.remove('zz-drawer-open'); } },
    render: function (cart) {
      var root = this.el;
      if (!root) return;
      var items = root.querySelector('[data-cart-items]');
      var countEls = document.querySelectorAll('[data-cart-count]');
      var total = root.querySelector('[data-cart-total]');
      var fill = root.querySelector('[data-ship-fill]');
      var msg = root.querySelector('[data-ship-msg]');
      var threshold = parseInt(root.getAttribute('data-free-threshold') || '0', 10);

      for (var i = 0; i < countEls.length; i++) countEls[i].textContent = cart.item_count;
      if (total) total.textContent = money(cart.total_price);

      root.classList.toggle('is-empty', !cart.items.length);

      if (!cart.items.length) {
        var emptyText = root.getAttribute('data-empty-text') || 'Sepetiniz henüz boş.';
        var emptyBtnLabel = root.getAttribute('data-empty-btn-label') || 'Alışverişe başla';
        var emptyBtnUrl = root.getAttribute('data-empty-btn-url') || '/';
        items.innerHTML = '<div class="zz-drawer__empty">' +
          '<p>' + emptyText + '</p>' +
          '<a href="' + emptyBtnUrl + '" class="zz-btn zz-btn--dark">' + emptyBtnLabel + '</a>' +
        '</div>';
      } else {
        var html = '';
        cart.items.forEach(function (li) {
          html += '<div class="zz-drawer__item">' +
            '<img src="' + (li.image ? li.image + (li.image.indexOf('?') > -1 ? '&' : '?') + 'width=124' : '') + '" alt="" loading="lazy" />' +
            '<div style="flex:1;min-width:0">' +
              '<div style="font-weight:700;font-size:14px;line-height:1.3">' + li.product_title + '</div>' +
              '<div style="font-size:13px;color:var(--zz-ink-soft);font-weight:700">' +
                (li.variant_title && li.variant_title !== 'Default Title' ? li.variant_title + ' · ' : '') +
                li.quantity + ' adet · ' + money(li.final_line_price) +
              '</div>' +
            '</div>' +
            '<button type="button" class="zz-drawer__remove" data-remove-key="' + li.key + '" aria-label="Kaldır" style="border:none;background:transparent;cursor:pointer;color:var(--zz-muted);font-size:18px">✕</button>' +
          '</div>';
        });
        items.innerHTML = html;
      }

      if (threshold > 0 && fill && msg) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        fill.style.width = pct + '%';
        var remaining = Math.max(0, threshold - cart.total_price);
        msg.textContent = cart.total_price === 0
          ? money(threshold) + ' ve üzeri kargo bedava.'
          : (remaining > 0 ? money(remaining) + ' daha ekleyin, kargo bedava!' : '🎉 Tebrikler, kargonuz bedava!');
      }
      updateGift(cart);
      updateUpsell(cart);
    },
    fetch: function () {
      var self = this;
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { self.render(c); });
    },
    change: function (body) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    add: function (id, qty) {
      var self = this;
      return fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
      }).then(function (r) { return r.json(); }).then(function () { self.fetch(); self.open(); });
    }
  };
  window.ZZDrawer = drawer;

  var esc = function (str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var onCartPage = function () { return /\/cart\/?$/.test(window.location.pathname); };

  /* ---------- cart gift tile (Theme settings > Sepet > Hediye kampanyası) ---------- */
  function updateGift(cart) {
    var tiles = document.querySelectorAll('[data-gift]');
    for (var i = 0; i < tiles.length; i++) {
      var t = tiles[i];
      var min = parseInt(t.getAttribute('data-gift-min') || '0', 10);
      var locked = min > 0 && cart.total_price < min;
      t.classList.toggle('is-locked', locked);
      var msg = t.querySelector('[data-gift-msg]');
      if (msg) msg.textContent = locked
        ? (t.getAttribute('data-locked-text') || '').replace('[kalan]', money(min - cart.total_price))
        : (t.getAttribute('data-unlocked-text') || '');
      var fill = t.querySelector('[data-gift-fill]');
      if (fill) fill.style.width = (min > 0 ? Math.min(100, cart.total_price / min * 100) : 100) + '%';
      var giftId = t.getAttribute('data-gift-variant');
      var inCart = cart.items.some(function (li) { return String(li.variant_id) === giftId; });
      var add = t.querySelector('[data-gift-add]');
      if (add) add.hidden = locked || inCart;
    }
  }

  /* ---------- cart suggestions: Shopify recommendations, topped up from a fallback collection ---------- */
  var upsellCache = { key: null, items: [] };
  function normalizeProduct(p) {
    var variants = (p.variants || []).filter(function (v) { return v.available; }).map(function (v) {
      return { id: v.id, title: v.title, price: typeof v.price === 'number' ? v.price : Math.round(parseFloat(v.price) * 100) };
    });
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && typeof img === 'object') img = img.src || img.url || '';
    return { id: p.id, title: p.title, url: p.url || ('/products/' + p.handle), image: img, variants: variants };
  }
  function renderUpsell(box, items) {
    var list = box.querySelector('[data-upsell-list]');
    if (!items.length) { box.hidden = true; return; }
    list.innerHTML = items.map(function (p) {
      var single = p.variants.length === 1;
      var src = p.image ? p.image.replace(/^\/\//, 'https://') : '';
      if (src) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
      return '<div class="zz-upsell__item">' +
        '<a href="' + esc(p.url) + '" class="zz-upsell__img">' + (src ? '<img src="' + esc(src) + '" alt="" loading="lazy" width="64" height="80">' : '') + '</a>' +
        '<div class="zz-upsell__info">' +
          '<a href="' + esc(p.url) + '" class="zz-upsell__t">' + esc(p.title) + '</a>' +
          '<div class="zz-upsell__p">' + money(p.variants[0].price) + '</div>' +
          (single ? '' : '<select class="zz-upsell__select" aria-label="Beden seçin" data-upsell-variant>' +
            p.variants.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>') +
        '</div>' +
        '<button type="button" class="zz-btn zz-btn--dark zz-upsell__add" data-upsell-add="' + p.variants[0].id + '">Ekle</button>' +
      '</div>';
    }).join('');
    box.hidden = false;
  }
  function updateUpsell(cart) {
    var boxes = document.querySelectorAll('[data-upsell]');
    if (!boxes.length) return;
    if (!cart.items.length) { for (var b = 0; b < boxes.length; b++) boxes[b].hidden = true; return; }
    var limit = parseInt(boxes[0].getAttribute('data-limit') || '4', 10);
    var fallback = boxes[0].getAttribute('data-fallback');
    var exclude = {};
    var ex = boxes[0].getAttribute('data-exclude');
    if (ex) exclude[ex] = true;
    cart.items.forEach(function (li) { exclude[li.product_id] = true; });
    var key = Object.keys(exclude).sort().join(',');
    var paint = function (items) { for (var i = 0; i < boxes.length; i++) renderUpsell(boxes[i], items); };
    if (upsellCache.key === key) { paint(upsellCache.items); return; }
    var root = window.Shopify.routes.root;
    var pick = function (pool, out) {
      pool.forEach(function (raw) {
        if (out.length >= limit) return;
        var p = normalizeProduct(raw);
        if (exclude[p.id] || !p.variants.length) return;
        exclude[p.id] = true;
        out.push(p);
      });
      return out;
    };
    fetch(root + 'recommendations/products.json?product_id=' + cart.items[0].product_id + '&limit=10&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; })
      .then(function (d) {
        var out = pick(d.products || [], []);
        if (out.length >= limit || !fallback) return out;
        return fetch(root + 'collections/' + fallback + '/products.json?limit=30')
          .then(function (r) { return r.ok ? r.json() : { products: [] }; })
          .catch(function () { return { products: [] }; })
          .then(function (c) { return pick(c.products || [], out); });
      })
      .then(function (items) { upsellCache = { key: key, items: items }; paint(items); });
  }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-upsell-variant]');
    if (!sel) return;
    var btn = sel.closest('.zz-upsell__item').querySelector('[data-upsell-add]');
    if (btn) btn.setAttribute('data-upsell-add', sel.value);
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-upsell-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true; btn.textContent = '…';
    if (onCartPage()) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: btn.getAttribute('data-upsell-add'), quantity: 1 }] })
      }).then(function () { window.location.reload(); });
    } else {
      drawer.add(btn.getAttribute('data-upsell-add'), 1);
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    drawer.el = document.querySelector('[data-cart-drawer]');
    drawer.overlay = document.querySelector('[data-cart-overlay]');
    if (drawer.el) drawer.fetch();
  });

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-open]');
    if (open) { e.preventDefault(); drawer.open(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-overlay]')) { drawer.close(); return; }
    var rm = e.target.closest('[data-remove-key]');
    if (rm) { drawer.change({ id: rm.getAttribute('data-remove-key'), quantity: 0 }); return; }

    /* quick add from cards */
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var vid = quick.getAttribute('data-quick-add');
      if (!vid) return;
      quick.disabled = true;
      var was = quick.textContent;
      quick.textContent = 'Ekleniyor…';
      drawer.add(vid, 1).then(function () {
        if (onCartPage()) { window.location.reload(); return; }
        quick.disabled = false; quick.textContent = was;
      });
    }

    /* mobile search toggle */
    var searchToggle = e.target.closest('[data-search-toggle]');
    if (searchToggle) {
      var searchForm = document.getElementById(searchToggle.getAttribute('aria-controls'));
      var searchOpen = searchForm.classList.toggle('is-open');
      searchToggle.setAttribute('aria-expanded', searchOpen ? 'true' : 'false');
      if (searchOpen) searchForm.querySelector('input').focus({ preventScroll: true });
    }

    /* mobile nav toggle */
    var navToggle = e.target.closest('[data-nav-toggle]');
    if (navToggle) {
      var panel = document.getElementById(navToggle.getAttribute('aria-controls'));
      var willOpen = navToggle.getAttribute('aria-expanded') !== 'true';
      navToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (panel) {
        if (willOpen) { panel.hidden = false; panel.setAttribute('data-open', ''); }
        else { panel.hidden = true; panel.removeAttribute('data-open'); }
      }
      return;
    }
    if (!e.target.closest('.zz-mobile-nav') && !e.target.closest('[data-nav-toggle]')) {
      var openPanel = document.querySelector('.zz-mobile-nav[data-open]');
      if (openPanel) {
        openPanel.hidden = true;
        openPanel.removeAttribute('data-open');
        var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 899) {
      var openPanel = document.querySelector('.zz-mobile-nav[data-open]');
      if (openPanel) { openPanel.hidden = true; openPanel.removeAttribute('data-open'); }
      var toggle = document.querySelector('[data-nav-toggle][aria-expanded="true"]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer.close(); });

  /* ---------- gallery: cap the thumbnail column to the main image's own
     height, so extra thumbnails scroll inside it (touch/finger works
     natively via overflow-y) instead of pushing the column taller than
     the image. Measured in JS because the thumb column's natural height
     (many small squares) can exceed the image's aspect-ratio height, so
     CSS alone (flex stretch) can't reliably cap it. ---------- */
  function syncGalleryHeight() {
    var main = document.querySelector('.zz-gallery__main');
    var thumbs = document.querySelector('.zz-gallery__thumbs');
    if (!main || !thumbs) return;
    var h = main.getBoundingClientRect().height;
    if (h > 0) thumbs.style.maxHeight = h + 'px';
  }
  window.addEventListener('load', syncGalleryHeight);
  window.addEventListener('resize', syncGalleryHeight);
  document.addEventListener('DOMContentLoaded', syncGalleryHeight);

  /* ---------- product form ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var pdp = document.querySelector('[data-pdp]');
    if (!pdp) return;
    var variants = JSON.parse(pdp.querySelector('[data-variants-json]').textContent);
    var idInput = pdp.querySelector('[data-variant-id]');
    var priceEl = pdp.querySelector('[data-price]');
    var oldEl = pdp.querySelector('[data-price-old]');
    var saveEl = pdp.querySelector('[data-price-save]');
    var atc = pdp.querySelectorAll('[data-atc]');
    var err = pdp.querySelector('[data-size-error]');
    var qtyInput = pdp.querySelector('[data-qty]');
    var totalEls = pdp.querySelectorAll('[data-total-label]');
    var sizeLabels = pdp.querySelectorAll('[data-size-label]');
    var qtyDisplays = pdp.querySelectorAll('[data-qty-display]');

    var selected = { size: '', color: pdp.getAttribute('data-initial-color') || '' };

    var hasSizes = !!pdp.querySelector('[data-size], [data-size-select]');
    function findVariant() {
      if (!hasSizes) {
        for (var n = 0; n < variants.length; n++) if (!selected.color || variants[n].options.indexOf(selected.color) > -1) return variants[n];
        return variants[0];
      }
      if (!selected.size) return null;
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (o.indexOf(selected.size) > -1 && (!selected.color || o.indexOf(selected.color) > -1)) return variants[i];
      }
      return null;
    }

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10)); }

    function showMedia(idx) {
      var imgs = pdp.querySelectorAll('[data-main-image]');
      for (var m = 0; m < imgs.length; m++) imgs[m].hidden = imgs[m].getAttribute('data-main-image') !== idx;
      var ts = pdp.querySelectorAll('[data-thumb]');
      var activeThumb = null;
      for (var t = 0; t < ts.length; t++) {
        var on = ts[t].getAttribute('data-thumb') === idx;
        ts[t].classList.toggle('is-on', on);
        if (on) activeThumb = ts[t];
      }
      if (activeThumb && activeThumb.scrollIntoView) {
        activeThumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function baseFileName(url) {
      if (!url) return '';
      return url.split('?')[0].split('/').pop();
    }

    function sizeAvailableForColor(sizeVal) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].options;
        if (o.indexOf(sizeVal) === -1) continue;
        if (selected.color && o.indexOf(selected.color) === -1) continue;
        if (variants[i].available) return true;
      }
      return false;
    }

    /* sold-out sizes are hidden (not just disabled); they reappear on their own once restocked */
    var sizeSelects = pdp.querySelectorAll('[data-size-select]');
    var sizeOptionsMaster = [];
    for (var ms = 0; ms < sizeSelects.length; ms++) {
      sizeOptionsMaster.push(Array.prototype.slice.call(sizeSelects[ms].options).map(function (op) { return { value: op.value, label: op.textContent }; }));
    }
    var noSizesLeft = false;
    function updateSizeAvailability() {
      var sizeEls = pdp.querySelectorAll('[data-size]');
      var anyOk = false;
      for (var s = 0; s < sizeEls.length; s++) {
        var okBtn = sizeAvailableForColor(sizeEls[s].getAttribute('data-size'));
        sizeEls[s].disabled = !okBtn;
        sizeEls[s].hidden = !okBtn;
        if (okBtn) anyOk = true;
      }
      for (var ss = 0; ss < sizeSelects.length; ss++) {
        var current = sizeSelects[ss].value;
        sizeSelects[ss].innerHTML = '';
        sizeOptionsMaster[ss].forEach(function (op) {
          if (op.value && !sizeAvailableForColor(op.value)) return;
          if (op.value) anyOk = true;
          var el = document.createElement('option');
          el.value = op.value; el.textContent = op.label;
          sizeSelects[ss].appendChild(el);
        });
        sizeSelects[ss].value = current && sizeAvailableForColor(current) ? current : '';
      }
      noSizesLeft = hasSizes && !anyOk;
      var none = pdp.querySelector('[data-size-none]');
      if (none) none.hidden = !noSizesLeft;
      if (selected.size && !sizeAvailableForColor(selected.size)) {
        selected.size = '';
        for (var a = 0; a < sizeEls.length; a++) sizeEls[a].classList.remove('is-on');
        var sels2 = pdp.querySelectorAll('[data-size-select]');
        for (var b = 0; b < sels2.length; b++) sels2[b].value = '';
      }
    }

    function syncMediaToColor() {
      if (!selected.color) return;
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].options.indexOf(selected.color) > -1 && variants[i].featured_image) { match = variants[i]; break; }
      }
      if (!match) return;
      var fname = baseFileName(match.featured_image.src);
      if (!fname) return;
      var imgs = pdp.querySelectorAll('[data-main-image]');
      for (var m = 0; m < imgs.length; m++) {
        if (baseFileName(imgs[m].getAttribute('data-media-src')) === fname) { showMedia(imgs[m].getAttribute('data-main-image')); return; }
      }
    }

    function sync() {
      var v = findVariant();
      var unit = v ? v.price : variants[0].price;
      var compare = v ? v.compare_at_price : variants[0].compare_at_price;
      if (priceEl) priceEl.textContent = money(unit);
      if (oldEl) { oldEl.textContent = compare > unit ? money(compare) : ''; oldEl.hidden = !(compare > unit); }
      if (saveEl) { saveEl.textContent = compare > unit ? money(compare - unit) + ' kazanç' : ''; saveEl.hidden = !(compare > unit); }
      for (var i = 0; i < totalEls.length; i++) totalEls[i].textContent = money(unit * qty());
      for (var q = 0; q < qtyDisplays.length; q++) qtyDisplays[q].textContent = qty();
      for (var j = 0; j < sizeLabels.length; j++) sizeLabels[j].textContent = selected.size || sizeLabels[j].getAttribute('data-placeholder') || 'seçiniz';
      if (idInput) idInput.value = v ? v.id : '';
      for (var k = 0; k < atc.length; k++) {
        var soldOut = (v && !v.available) || noSizesLeft;
        atc[k].disabled = !!soldOut;
        atc[k].textContent = soldOut ? 'Tükendi' : (atc[k].getAttribute('data-label') || 'Sepete ekle');
        if (!soldOut && atc[k].hasAttribute('data-show-total')) {
          atc[k].textContent = (atc[k].getAttribute('data-label') || 'Sepete ekle') + ' · ' + money(unit * qty());
        }
      }
    }

    function setColor(color) {
      selected.color = color;
      var sws = pdp.querySelectorAll('[data-color]');
      for (var c = 0; c < sws.length; c++) sws[c].classList.toggle('is-on', sws[c].getAttribute('data-color') === color);
      var cls = pdp.querySelectorAll('[data-color-select]');
      for (var k = 0; k < cls.length; k++) cls[k].value = color;
      for (var q = 0; q < sws.length; q++) {
        if (sws[q].getAttribute('data-color') === color) {
          var swImg = sws[q].querySelector('img');
          var thumbs = pdp.querySelectorAll('[data-color-thumb]');
          for (var t = 0; swImg && t < thumbs.length; t++) thumbs[t].src = swImg.src;
          break;
        }
      }
      var cl = pdp.querySelectorAll('[data-color-label]');
      for (var d = 0; d < cl.length; d++) cl[d].textContent = color;
      syncMediaToColor();
      updateSizeAvailability();
      sync();
    }

    function clearSizeError() {
      if (err) err.hidden = true;
    }
    function showSizeError() {
      if (err) err.hidden = false;
      var sels = pdp.querySelectorAll('[data-size-select]');
      var target = null;
      for (var s = 0; s < sels.length; s++) {
        if (!target && sels[s].offsetParent !== null) target = sels[s];
      }
      if (target) {
        if (typeof target.showPicker === 'function') {
          try { target.showPicker(); } catch (e) { target.focus(); }
        } else {
          target.focus();
        }
      }
    }

    pdp.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-size]');
      if (btn && !btn.disabled) {
        selected.size = btn.getAttribute('data-size');
        var all = pdp.querySelectorAll('[data-size]');
        for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === btn);
        var sels = pdp.querySelectorAll('[data-size-select]');
        for (var s = 0; s < sels.length; s++) sels[s].value = selected.size;
        clearSizeError();
        sync();
      }
      var sw = e.target.closest('[data-color]');
      if (sw) setColor(sw.getAttribute('data-color'));
      var thumb = e.target.closest('[data-thumb]');
      if (thumb) {
        showMedia(thumb.getAttribute('data-thumb'));
      }
      var step = e.target.closest('[data-qty-step]');
      if (step && qtyInput) {
        qtyInput.value = Math.max(1, qty() + parseInt(step.getAttribute('data-qty-step'), 10));
        sync();
      }
      var guide = e.target.closest('[data-guide-toggle]');
      if (guide) {
        var panel = pdp.querySelector('[data-guide]');
        if (panel) panel.hidden = !panel.hidden;
      }
      var tab = e.target.closest('[data-tab]');
      if (tab) {
        var name = tab.getAttribute('data-tab');
        var tabs = pdp.querySelectorAll('[data-tab]');
        for (var x = 0; x < tabs.length; x++) {
          var on = tabs[x] === tab;
          tabs[x].classList.toggle('is-on', on);
          tabs[x].setAttribute('aria-selected', on ? 'true' : 'false');
        }
        var panels = pdp.querySelectorAll('[data-tabpanel]');
        for (var y = 0; y < panels.length; y++) panels[y].hidden = panels[y].getAttribute('data-tabpanel') !== name;
      }
    });

    pdp.addEventListener('change', function (e) {
      var colorSel = e.target.closest('[data-color-select]');
      if (colorSel) setColor(colorSel.value);
      var sel = e.target.closest('[data-size-select]');
      if (sel) {
        selected.size = sel.value;
        var btns = pdp.querySelectorAll('[data-size]');
        for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-on', btns[i].getAttribute('data-size') === selected.size);
        var sels = pdp.querySelectorAll('[data-size-select]');
        for (var s = 0; s < sels.length; s++) sels[s].value = selected.size;
        clearSizeError();
        sync();
      }
      if (e.target.closest('[data-qty]')) sync();
    });

    /* add to cart (AJAX) */
    var forms = pdp.querySelectorAll('form[action*="/cart/add"]');
    for (var fi = 0; fi < forms.length; fi++) {
      forms[fi].addEventListener('submit', function (e) {
        e.preventDefault();
        var v = findVariant();
        if (!v) { showSizeError(); return; }
        drawer.add(v.id, qty());
      });
    }

    /* sticky bar reveal (desktop) */
    var sticky = document.querySelector('[data-sticky-buy]');
    if (sticky) {
      window.addEventListener('scroll', function () {
        var on = window.scrollY > 700;
        sticky.classList.toggle('is-on', on);
        document.body.classList.toggle('zz-sticky-buy-open', on);
      }, { passive: true });
    }

    /* ships-today countdown (Turkey time, Europe/Istanbul) */
    var cutoffEls = pdp.querySelectorAll('[data-cutoff]');
    if (cutoffEls.length) {
      var hour = parseInt(cutoffEls[0].getAttribute('data-cutoff') || '12', 10);
      var labelEls = pdp.querySelectorAll('[data-ship-label]');
      var timerWraps = pdp.querySelectorAll('[data-ship-timer-wrap]');

      var istanbulNow = function () {
        var fmt = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Istanbul', hour12: false,
          year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        });
        var parts = {};
        fmt.formatToParts(new Date()).forEach(function (p) { if (p.type !== 'literal') parts[p.type] = p.value; });
        if (parts.hour === '24') parts.hour = '00';
        return new Date(parts.year + '-' + parts.month + '-' + parts.day + 'T' + parts.hour + ':' + parts.minute + ':' + parts.second);
      };

      var tick = function () {
        var now = istanbulNow();
        var day = now.getDay(); /* 0 = Sunday, 6 = Saturday */
        var cutoffToday = new Date(now); cutoffToday.setHours(hour, 0, 0, 0);
        var mode, target;
        if (day === 0) {
          mode = 'monday';
        } else if (now < cutoffToday) {
          mode = 'today'; target = cutoffToday;
        } else if (day === 6) {
          mode = 'monday'; /* Saturday after cutoff: Sunday has no shipping, so next is Monday */
        } else {
          mode = 'tomorrow';
        }

        var label = mode === 'today' ? 'Bugün kargoda' : (mode === 'tomorrow' ? 'Yarın kargoda' : 'Pazartesi kargoda');
        for (var l = 0; l < labelEls.length; l++) labelEls[l].textContent = label;
        for (var w = 0; w < timerWraps.length; w++) timerWraps[w].hidden = mode !== 'today';

        if (mode === 'today') {
          var d = Math.floor((target - now) / 1000);
          var p = function (n) { return String(n).padStart(2, '0'); };
          var txt = p(Math.floor(d / 3600)) + ':' + p(Math.floor(d / 60) % 60) + ':' + p(d % 60);
          for (var i = 0; i < cutoffEls.length; i++) cutoffEls[i].textContent = txt;
        }
      };
      tick(); setInterval(tick, 1000);
    }

    syncMediaToColor();
    updateSizeAvailability();
    sync();
  });

  /* ---------- product description "Daha Fazla" ---------- */
  function measureReadmore() {
    var boxes = document.querySelectorAll('[data-readmore]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var body = box.querySelector('.zz-readmore__body');
      var btn = box.querySelector('[data-readmore-toggle]');
      if (!body || !btn || box.classList.contains('is-open') || !body.offsetParent) continue;
      var limit = parseInt(getComputedStyle(box).getPropertyValue('--zz-rm-h'), 10) || 160;
      var tall = body.scrollHeight > limit + 40;
      box.classList.toggle('is-clamped', tall);
      btn.hidden = !tall;
    }
  }
  document.addEventListener('DOMContentLoaded', measureReadmore);
  window.addEventListener('load', measureReadmore);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-tab]')) { setTimeout(measureReadmore, 0); return; }
    var btn = e.target.closest('[data-readmore-toggle]');
    if (!btn) return;
    var box = btn.closest('[data-readmore]');
    var open = !box.classList.contains('is-open');
    box.classList.toggle('is-open', open);
    box.classList.toggle('is-clamped', !open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
    if (!open) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  });

  /* ---------- campaign pop-up (section "Kampanya pop-up") ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var pop = document.querySelector('[data-promo]');
    if (!pop) return;
    var teaser = document.querySelector('[data-promo-teaser]');
    var key = pop.getAttribute('data-key') || 'zz-promo';
    var days = parseInt(pop.getAttribute('data-days') || '0', 10);
    var design = pop.hasAttribute('data-design-mode');
    var store = {
      get: function () { try { return parseInt(localStorage.getItem(key) || '0', 10); } catch (e) { return 0; } },
      set: function () { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
    };
    var lastFocus = null;
    var open = function () {
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { pop.classList.add('is-on'); });
      if (teaser) teaser.hidden = true;
      var close = pop.querySelector('.zz-promo__close');
      if (close) close.focus({ preventScroll: true });
    };
    var close = function () {
      pop.classList.remove('is-on');
      setTimeout(function () { pop.hidden = true; }, 250);
      store.set();
      if (teaser) teaser.hidden = false;
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };
    var last = store.get();
    var snoozed = last && (days === 0 ? false : Date.now() - last < days * 86400000);
    var showStep = function (name) {
      var steps = pop.querySelectorAll('[data-promo-step]');
      for (var i = 0; i < steps.length; i++) steps[i].hidden = steps[i].getAttribute('data-promo-step') !== name;
    };
    var justSignedUp = !!pop.querySelector('[data-promo-success-onload]');
    var formError = pop.querySelector('[data-promo-error]');
    if (justSignedUp || (formError && !formError.hidden)) {
      /* came back from a normal (non-AJAX) form post: show the code / error right away */
      open();
      if (justSignedUp) store.set();
    } else if (design) {
      open();
    } else if (snoozed) {
      if (teaser) teaser.hidden = false;
    } else {
      setTimeout(open, (parseInt(pop.getAttribute('data-delay') || '5', 10)) * 1000);
    }
    /* email signup: post in the background, then swap the form for the discount code.
       If Shopify asks for a captcha, fall back to a normal submit (the code shows after reload). */
    var form = pop.querySelector('.zz-promo__form');
    if (form) form.addEventListener('submit', function (e) {
      if (form.hasAttribute('data-native')) return;
      e.preventDefault();
      var btn = form.querySelector('[data-promo-submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Gönderiliyor…'; }
      if (formError) formError.hidden = true;
      fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
        .then(function (r) {
          if (/challenge/.test(r.url)) throw new Error('challenge');
          return r.text().then(function (html) { return { url: r.url, html: html }; });
        })
        .then(function (res) {
          var doc = new DOMParser().parseFromString(res.html, 'text/html');
          var ok = /customer_posted=true/.test(res.url) || doc.querySelector('[data-promo-success-onload]');
          if (ok) { showStep('success'); store.set(); return; }
          var err = doc.querySelector('[data-promo-error]');
          if (formError) {
            if (err && err.textContent.trim()) formError.textContent = err.textContent.trim();
            formError.hidden = false;
          }
          if (btn) { btn.disabled = false; btn.textContent = label; }
        })
        .catch(function () { form.setAttribute('data-native', ''); form.submit(); });
    });

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-promo-close]')) { close(); return; }
      if (e.target.closest('[data-promo-close-link]')) store.set();
      if (e.target.closest('[data-promo-cta]')) store.set();
      var copy = e.target.closest('[data-promo-copy]');
      if (copy) {
        var code = copy.getAttribute('data-promo-copy');
        var label = copy.querySelector('[data-promo-copy-label]');
        var done = function () { if (label) label.textContent = 'Kopyalandı ✓'; };
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) close(); });
    if (teaser) teaser.addEventListener('click', open);
    document.addEventListener('shopify:section:select', function (e) { if (pop.closest('.shopify-section') === e.target) open(); });
  });

  /* ---------- sticky support button ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var supp = document.querySelector('[data-support]');
    if (!supp) return;
    var toggle = supp.querySelector('[data-support-toggle]');
    document.addEventListener('click', function (e) {
      if (toggle.contains(e.target)) {
        supp.classList.toggle('is-open');
        return;
      }
      if (!supp.contains(e.target)) supp.classList.remove('is-open');
    });
  });

  /* ---------- generic campaign countdown ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-countdown-to]');
    if (!els.length) return;
    var tick = function () {
      for (var i = 0; i < els.length; i++) {
        var target = new Date(els[i].getAttribute('data-countdown-to')).getTime();
        var left = Math.max(0, target - Date.now());
        var p = function (n) { return String(n).padStart(2, '0'); };
        var days = Math.floor(left / 86400000);
        els[i].textContent = (days > 0 ? days + 'g ' : '') +
          p(Math.floor(left / 3600000) % 24) + ':' + p(Math.floor(left / 60000) % 60) + ':' + p(Math.floor(left / 1000) % 60);
      }
    };
    tick(); setInterval(tick, 1000);
  });

  /* ---------- collection: native Shopify filters + sort + load more ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-collection]');
    if (!root) return;
    var sortSel = root.querySelector('[data-sort]');
    if (sortSel) sortSel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sortSel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
    var stock = root.querySelector('[data-stock-filter]');
    if (stock) stock.addEventListener('change', function () {
      window.location.href = stock.checked ? stock.getAttribute('data-url-on') : stock.getAttribute('data-url-off');
    });

    var grid = root.querySelector('[data-collection-grid]');
    var more = root.querySelector('[data-load-more]');
    var label = root.querySelector('[data-shown-label]');
    var fill = root.querySelector('[data-shown-fill]');
    var total = parseInt(root.getAttribute('data-total') || '0', 10);
    function update() {
      var n = grid.querySelectorAll('[data-product-card]').length;
      if (label) label.textContent = n + ' / ' + total + ' ürün görüntüleniyor';
      if (fill) fill.style.width = (total ? (n / total) * 100 : 0) + '%';
    }

    /* Sold-out products last across the whole category: load every in-stock
       product first (availability filter), then scan the unfiltered pages and
       append only the sold-out ones. Without the filter we fall back to the
       plain page-by-page load (each page is already sorted in Liquid). */
    var instockUrl = root.getAttribute('data-instock-url');
    if (more && instockUrl) {
      var perPage = parseInt(root.getAttribute('data-per-page') || '24', 10);
      var sectionId = root.getAttribute('data-section-id');
      var here = new URL(window.location.href);
      var sortBy = here.searchParams.get('sort_by');
      var streams = [
        { url: new URL(instockUrl, window.location.origin), page: 1, done: false, soldOnly: false },
        { url: new URL(window.location.pathname + window.location.search, window.location.origin), page: 1, done: false, soldOnly: true }
      ];
      streams.forEach(function (s) {
        s.url.hash = '';
        s.url.searchParams.delete('page');
        if (sortBy) s.url.searchParams.set('sort_by', sortBy);
        if (sectionId) s.url.searchParams.set('section_id', sectionId);
      });
      var seen = {};
      var initial = grid.querySelectorAll('[data-product-card]');
      for (var ci = 0; ci < initial.length; ci++) {
        /* page-1 sold-out cards move to the very end, so take them out for now */
        if (initial[ci].getAttribute('data-available') === 'false') initial[ci].remove();
        else seen[initial[ci].getAttribute('data-product-id')] = true;
      }
      var fetchPage = function (s) {
        var u = new URL(s.url.toString());
        u.searchParams.set('page', s.page);
        return fetch(u.toString()).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('[data-collection-grid] [data-product-card]');
          var added = 0;
          for (var i = 0; i < cards.length; i++) {
            var id = cards[i].getAttribute('data-product-id');
            var sold = cards[i].getAttribute('data-available') === 'false';
            if (seen[id] || (s.soldOnly && !sold)) continue;
            seen[id] = true;
            grid.appendChild(cards[i]);
            added++;
          }
          s.page++;
          if (!doc.querySelector('[data-load-more]') || !cards.length) s.done = true;
          return added;
        });
      };
      var loadBatch = function (got) {
        var s = streams[0].done ? streams[1] : streams[0];
        if (s.done) return Promise.resolve(got);
        return fetchPage(s).then(function (added) {
          got += added;
          return got >= perPage ? got : loadBatch(got);
        });
      };
      more.addEventListener('click', function () {
        more.disabled = true; more.textContent = 'Yükleniyor…';
        loadBatch(0).then(function () {
          if (streams[0].done && streams[1].done) more.hidden = true;
          else { more.disabled = false; more.textContent = 'Daha fazla ürün'; }
          update();
        }).catch(function () { more.disabled = false; more.textContent = 'Daha fazla ürün'; });
      });
      update();
      return;
    }

    if (more) more.addEventListener('click', function () {
      var next = more.getAttribute('data-next');
      if (!next) return;
      more.disabled = true; more.textContent = 'Yükleniyor…';
      fetch(next).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = doc.querySelectorAll('[data-collection-grid] [data-product-card]');
        for (var i = 0; i < cards.length; i++) grid.appendChild(cards[i]);
        var nb = doc.querySelector('[data-load-more]');
        var n = nb ? nb.getAttribute('data-next') : '';
        if (n) { more.setAttribute('data-next', n); more.disabled = false; more.textContent = 'Daha fazla ürün'; }
        else more.hidden = true;
        update();
      });
    });
    update();
  });
})();
